import { render, staticRenderFns } from "./HUD.vue?vue&type=template&id=5c23475b&scoped=true&"
import script from "./HUD.vue?vue&type=script&lang=js&"
export * from "./HUD.vue?vue&type=script&lang=js&"
import style0 from "./HUD.vue?vue&type=style&index=0&id=5c23475b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c23475b",
  null
  
)

export default component.exports